// extracted by mini-css-extract-plugin
export default {"media":"Media--media--K1ODc","media-center":"Media--media-center--ZqXuB","mediaCenter":"Media--media-center--ZqXuB"};